import React from 'react';
import styles from './ProductCard.module.css';
import { useNavigate } from 'react-router-dom';

export default function ProductCard({ product }) {
  const {
    brand, brandShort, discount, name, subtitle, specs,
    image, price, available, id, source
  } = product;
  const navigate = useNavigate();

  const onOpen = () => {
    // Keep your route as /product/:id (you had this already)
    // Pass the raw item for internet products so View page doesn’t need to refetch.
    if (source === 'internet') {
      navigate(`/product/${encodeURIComponent(id)}`, { state: { source: 'internet', product } });
    } else {
      navigate(`/product/${id}`);
    }
  };

  return (
    <div className={styles.card}>
      {discount ? <span className={styles.badge}>{discount}%</span> : null}
      {brandShort ? <span className={styles.brand}>{brandShort}</span> : null}

      <div className={styles.imgBox} style={{ position:'relative' }}>
        {source === 'internet' && (
          <span className={styles.sourcePill} title="Fetched from Internet">Internet</span>
        )}
        <img src={image} alt={name} loading="lazy" draggable={false} />
      </div>

      <div className={styles.body}>
        <div className={styles.titleRow}>
          <div className={styles.title}>{name}</div>
          <div
            className={available ? styles.dotGreen : styles.dotGray}
            title={available ? 'In stock' : 'Out of stock'}
          />
        </div>
        {/* <div className={styles.subtitle}>{subtitle}</div> */}
        <ul className={styles.specs}>
          {(specs || []).slice(0, 5).map((s, i) => <li key={i}>{s}</li>)}
        </ul>
      </div>

      <div className={styles.footer}>
        <div className={styles.price}>${Number(price || 0).toFixed(2)}</div>
        <button className={styles.btn} onClick={onOpen}>View specs</button>
      </div>
    </div>
  );
}
